import { Typography } from "@mui/material";
import React from "react";
import AvailableInceptionFi from "../AvailableInceptionFi/AvailableInceptionFi";
import InceptionFiHeader from "../InceptionFiHeader/InceptionFiHeader";

const InceptionFi = () => {
  document.title = "Physics Admission Batch ~ Physics Of Stupid";
  return (
    <div>
      <InceptionFiHeader />

      <Typography sx={{ mt: "10px", px: "4px" }} variant="body1" gutterBottom>
        শুরু করা যাক নতুন এক সূচনা🚀
      </Typography>

      <AvailableInceptionFi />
    </div>
  );
};

export default InceptionFi;
